import SmartLockApiCallerInstance from '../utils/SmartLockApiCallerInstance';
import { SMART_LOCK_API_ENDPOINTS } from '../URLConstants';

export const GetAllTripData = async (page, search, sortBy, filterBy) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.TRIP_URL}?page=${page}&limit=10&search=${search}&sortField=${sortBy[0]}&sortOrder=${sortBy[1]}&filterBy=${filterBy}`
  );
  return response;
};

export const CreateTripData = async (data) => {
  const response = await SmartLockApiCallerInstance.post(SMART_LOCK_API_ENDPOINTS.TRIP_URL, data);
  return response;
};

export const StartTripById = async (tripId, data) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.TRIP_START}/${tripId}`,
    data
  );
  return response;
};

export const UpdateDriverDetails = async (id, data) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.UPDATE_DRIVER_DETAILS}/${id}`,
    data
  );
  return response;
};

export const GetTripDetailsById = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.TRIP_URL}/${id}`
  );
  return response;
};

export const GetTripData = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.TRIP_DATA}/${id}`
  );
  return response;
};
export const GetTripEvents = async (id, deviceId, page, limit, type) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.TRIP_DATA_EVENTS}/${id}?deviceId=${deviceId}&page=${page}&limit=${limit}&type=${type}`
  );
  return response;
};

export const EndTripById = async (id, data) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.END_TRIP}/${id}`,
    data
  );
  return response;
};

export const DeleteTripById = async (id) => {
  const response = await SmartLockApiCallerInstance.delete(
    `${SMART_LOCK_API_ENDPOINTS.TRIP_URL}/${id}`
  );
  return response;
};

export const UpdateGeoFenceStatus = async (id, status) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.UPDATE_GEOFENCE}/${id}?geoFenceStatus=${status}`
  );
  return response;
};

export const TrackingTripLocationData = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.TRACKING_TRIP_LOCATION}/${id}`
  );
  return response;
};
export const SendDeviceUnlockCommand = async (data) => {
  const response = await SmartLockApiCallerInstance.post(
    SMART_LOCK_API_ENDPOINTS.OPEN_LOCK_COMMAND,
    data
  );
  return response;
};

// /-------------------------------------------------------/
